import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';
import { MuiInput } from '../../shared/form-element';
import { CreateDialogViewTemplate } from '../create-dialog-template/create-dialog-view-template';

const vt = viewTexts.dialogs.createNewProject;

const InputWrapper = styled.div`
  padding: 5px;
`;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  registererName: string;
  projectName: string | undefined;
  projectNameErrors: string[] | undefined;
  projectNameOnInput: (v: string) => void;
  submitButtonEnabled: boolean;
  nonFieldErrors: string[];
}

export const CreateNewProjectDialogView: FC<Props> = memo(
  ({
    open,
    onClose,
    registererName,
    projectName = '',
    projectNameErrors = [],
    projectNameOnInput,
    submitButtonEnabled,
    nonFieldErrors
  }: Readonly<Props>) => (
    <CreateDialogViewTemplate
      open={open}
      onClose={onClose}
      title={vt.title}
      descriptions={vt.descriptions}
      submitButtonEnabled={submitButtonEnabled}
      nonFieldErrors={nonFieldErrors}
    >
      <InputWrapper>
        <MuiInput
          label={vt.labels.registerer}
          required={true}
          value={registererName}
          disabled={true}
        />
      </InputWrapper>
      <InputWrapper>
        <MuiInput
          label={vt.labels.projectName}
          required={true}
          value={projectName}
          onInput={projectNameOnInput}
          helperText={projectNameErrors.join(' ')}
          error={projectNameErrors.length > 0}
        />
      </InputWrapper>
    </CreateDialogViewTemplate>
  )
);

CreateNewProjectDialogView.displayName = 'CreateNewProjectDialogView';
